/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react'
import qs from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'

const usePagination = (options = 5) => {
  const {
    initialPerPage = 5,
    pageLabel = 'page',
    resetPage,
    localState = false,
  } = typeof options === 'object' ? options : { initialPerPage: options }

  const location = useLocation()
  const history = useHistory()
  const search = qs.parse(location.search)

  const urlPage = parseInt(search[pageLabel]) || 1

  const [query, setQuery] = useState({
    [pageLabel]: localState ? 1 : urlPage,
    ...(localState ? {} : search),
  })
  const [perPage, setRowsPerPage] = useState(initialPerPage)

  const page = localState ? query[pageLabel] : urlPage

  const handleChangePage = (event, newPage) => {
    setQuery({
      ...(localState ? query : search),
      [pageLabel]: newPage + 1,
    })
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    handleChangePage({}, 0)
  }

  useEffect(() => {
    if (localState) return

    history.replace(location.pathname + '?' + qs.stringify(query))
  }, [history, location.pathname, query])

  const isFirstRenderReference = useRef(true)

  useEffect(() => {
    if (isFirstRenderReference.current) {
      isFirstRenderReference.current = false
      return
    }

    if (resetPage === undefined) return

    handleChangePage({}, 0)
  }, [resetPage])

  return { page, perPage, handleChangePage, handleChangeRowsPerPage }
}

export default usePagination
